/**
 * Retourne les dates de début/fin de la période de paie courante (cycle 21→20).
 * Si on est après le 21 du mois : du 21 courant au 20 du mois suivant.
 * Sinon : du 21 du mois précédent au 20 du mois courant.
 */
const fmtLocal = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const j = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${j}`;
};

export const getDefaultDates = () => {
  const today = new Date();
  const day = today.getDate();
  const month = today.getMonth();
  const year = today.getFullYear();

  let startDate;
  let endDate;

  if (day >= 21) {
    startDate = new Date(year, month, 21);
    endDate = new Date(year, month + 1, 20);
  } else {
    startDate = new Date(year, month - 1, 21);
    endDate = new Date(year, month, 20);
  }

  return {
    startDate: fmtLocal(startDate),
    endDate: fmtLocal(endDate)
  };
};

/**
 * Retourne la date d'aujourd'hui au format YYYY-MM-DD.
 */
export const getToday = () => new Date().toISOString().split('T')[0];
